import { NgModule, inject, provideAppInitializer } from '@angular/core';
import {CommonModule} from '@angular/common';
import {PiwikService} from './piwik.service';
import {PiwikScriptComponent} from './piwik-script.component';
import {PiwikDirective} from '@wba/commons/modules/piwik/piwik.directive';

/**
 * Wenn die Angular APP initialisiert ist (APP_INITIALIZER), dann lade automatisch das Piwik Script in den DOM (piwikService.init())
 *
 * Vorteil:
 * Somit sparen wir uns den Aufruf von piwikService.init() in der app.component.ts
 *
 * Hinweis:
 * Das PiwikModule sollte ins AppModule importiert werden
 *
 * Siehe:
 * https://angular.io/guide/dependency-injection-providers#predefined-tokens-and-multiple-providers
 *
 * @param piwikService
 */
export function init_piwik(piwikService: PiwikService) {
  return () => piwikService.init();
}

@NgModule({
  declarations: [
    PiwikScriptComponent,
    PiwikDirective
  ],
  providers: [
    PiwikService,
    provideAppInitializer(() => {
        const initializerFn = (init_piwik)(inject(PiwikService));
        return initializerFn();
      })
  ],
  exports: [
    PiwikDirective
  ],
  imports: [
    CommonModule
  ]
})
export class PiwikModule {
}
